import { ImportError } from '@models/import-settings';
import { Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy, ViewContainerRef } from '@angular/core';
import { ImporterState } from '@interfaces/importer-state';
import { Globals } from '@models/globals';
import { DatasetsService } from '@services/datasets/datasets.service';
import { CanDeactivateGuard } from '@services/guards/can-deactivate/can-deactivate-guard.service';
import { MenuService } from '@services/menu/menu.service';
import { interval, Subject, Subscription } from 'rxjs';
import { switchMap, map, distinctUntilChanged, tap, takeWhile, takeUntil } from 'rxjs/operators';
import { ImporterService } from '@services/datasets/importer.service';
import { DialogComponent } from '@core/dialog/dialog.component';
import { NotificationsService } from '@services/notifications/notifications.service';
import {Toast} from 'ngx-toastr';
import { WindowRef, WindowService } from '@progress/kendo-angular-dialog';
import { ImportErrorDisplayComponent } from './import-error-display/import-error-display.component';
import { BlobServiceClient, BlockBlobUploadOptions } from '@azure/storage-blob';
import { ToastLevel } from '@shared/toasterSetup';

let json: string[];
@Component({
  selector: 'app-import-alm-dataset',
  templateUrl: './import-alm-dataset.component.html',
  styleUrls: ['./import-alm-dataset.component.scss'],
})
export class ImportAlmDatasetComponent implements OnInit, CanDeactivateGuard, OnDestroy {
  hostStyle = {
    width: '100%',
    height: '100%',
  };
  private step = 1;
  showDrag = true;
  validData = false;

  private onDestroy$ = new Subject();
  blobServiceClient: BlobServiceClient;

  // Tracks importer status
  get ImporterState() {
    return ImporterState;
  }

  get importerStatus$() {
    return this.importerService.importerStatus$.getValue();
  }
  // Enable sections in the frontend
  public fileUploaded = false;
  public fileImported = false;
  public fileAggregated = false;
  public isReaggregation = false;
  public displayErrors = 'none';
  public aggregationAvailable = false;
  public importAvailable = false;
  public import_cp_date = '';
  public import_datasets = [];
  public current_datasests = [];
  public uploadStyle = '';
  public importStyle = '';
  public aggregationStyle = '';
  public uploadCompleteStyle = '';
  public importCompleteStyle = '';
  public aggregationCompleteStyle = '';

  public isAzure: boolean;
  private currentFile: File;

  public importErrors: any[] = [];
  public aggregationErrors: any[] = [];

  toastDismissed: Date = null;
  public cpDate = '';
  public importing = false;
  public percent = 0;
  public filename = '';
  public imported = false;
  public errorText = '';
  private dataContainer: ElementRef;
  private Config = {
    sas: '',
    storageAccount: '',
    containerName: '',
    URL: '',
  };
  @ViewChild('errorContainer', { static: false }) set content(content: ElementRef) {
    this.dataContainer = content;
  }

  @ViewChild('container', { static: false, read: ViewContainerRef }) public containerRef: ViewContainerRef;
  private windowRef: WindowRef = null;

  public isErrorDialogOpen = false;
  public lastImportErrorsFilter: string;
  public lastAggregationDate: Date;
  public lastImportDate: Date;
  public lastImportSucess: boolean;
  private subscription: Subscription = null;

  constructor(
    private datasetService: DatasetsService,
    private menu: MenuService,
    private importerService: ImporterService,
    private comp: DialogComponent,
    private notifications: NotificationsService,
    private windowService: WindowService
  ) {}

  async canDeactivate(): Promise<boolean> {
    return this.menu.canDeactivatePopup();
  }

  ngOnInit() {
    this.importerService.importerStatus$.next(ImporterState.idle);

    this.datasetService
      .GetImportSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(res => {
        console.log('TCL ~ file: import-alm-dataset.component.ts ~ line 115 ~ ImportAlmDatasetComponent ~ ngOnInit ~ res', res);
        this.aggregationAvailable = res.Reaggregate;
        this.importAvailable = res.Import_Available;
        this.import_cp_date = res.Import_CP_Date;
        this.cpDate = res.CP_Date;
        this.import_datasets = res.Importing_Datasets;
        this.current_datasests = res.Current_Datasets;
        this.Config.storageAccount = res.StorageAccount;
        this.Config.sas = res.SAS;
        this.Config.containerName = res.Container;
        this.Config.URL = res.URL;
        this.isAzure = res.Use_Azure;
        this.setupActiveImport(res);

        if (res.LastImport) {
          const lastImportErrors = res.LastImport.ImportErrors
            ? res.LastImport.ImportErrors.map(err => ({
                ...err,
                dataset: err.dataset.toUpperCase(),
              })).sort((a, b) => a.dataset.localeCompare(b.dataset))
            : [];
          this.aggregationErrors = lastImportErrors.filter(err => err.ImportStep === 2);
          this.importErrors = lastImportErrors.filter(err => err.ImportStep === 1);

          this.lastAggregationDate = res.LastImport.file_aggregation_success ? res.LastImport.file_aggregation_finish_date : null;
          this.lastImportDate = res.LastImport.file_import_success
            ? res.LastImport.file_import_finish_date
            : res.LastImport.file_import_start_date;
          this.lastImportSucess = res.LastImport.file_import_success;
        } else {
          this.lastAggregationDate = null;
          this.lastImportDate = null;
          this.aggregationErrors = [];
          this.importErrors = [];
        }
      });

    this.importerService.importerStatus$.pipe(takeUntil(this.onDestroy$)).subscribe(status => {
      this.menu.selectedMenuItemCanDeactivate(false);
      switch (status) {
        case ImporterState.fileAggregated:
          this.fileAggregated = true;
          this.menu.selectedMenuItemCanDeactivate(true);
          break;
        case ImporterState.fileImported:
          this.fileImported = true;
          break;
        case ImporterState.fileUploaded:
          this.fileUploaded = true;
          break;
        case ImporterState.idle:
          this.menu.selectedMenuItemCanDeactivate(true);
          break;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    this.showDrag = true;
    if (files.length > 0) {
    }
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.showDrag = false;
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    this.initiateUpload(files);
  }

  private initiateUpload(files: any) {
    this.reset();
    this.importing = true;
    this.filename = files[0].name;
    this.currentFile = files[0];
    this.importerService.importerStatus$.next(ImporterState.fileUploading);
    this.showDrag = false;
    const reader = new FileReader();
    let headers: string[];
    this.uploadStyle = this.getStepStyle(false);

    reader.onload = function () {
      const csv = reader.result as string; // the entire file
      const allTextLines = csv.split('\n');
      headers = allTextLines[0].split(','); // use the console for debugging
      headers.forEach(element => {
        element = element.replace(/(\r\n|\n|\r)/gm, '');
      });
      json = headers;
    };

    this.currentFile.size > 10000 ? reader.readAsText(this.currentFile.slice(0, 10000)) : reader.readAsText(this.currentFile, 'UTF-8');

    if (this.isAzure) {
      this.uploadToAzure();
    } else {
      this.datasetService
        .uploadFile(this.currentFile, this.filename)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          res => this.onFileUploadSuccess(1),
          err => this.onFileUploadFailure(err)
        );
    }
  }

  /**
   * @param {File|Blob} - file to slice
   * @param {Number} - chunksAmount
   * @return {Array} - an array of Blobs
   **/
  private sliceFile(file, chunksAmount): Blob {
    var byteIndex = 0;

    let text: string = '';

    for (var i = 0; i < chunksAmount; i += 1) {
      var byteEnd = Math.ceil((file.size / chunksAmount) * (i + 1));
      text = file.slice(byteIndex, byteEnd);
      byteIndex += byteEnd - byteIndex;
    }

    return new Blob([text]);
  }
  public fileSelectChange(fileInput: any) {
    const files = fileInput.target.files;
    this.initiateUpload(files);
  }

  private reset() {
    this.percent = 0;
    this.importerService.importerStatus$.next(ImporterState.idle);
    this.importCompleteStyle = '';
    this.importErrors = [];
    this.aggregationCompleteStyle = '';
    this.aggregationErrors = [];
    this.uploadCompleteStyle = '';
    this.uploadStyle = '';
    this.importStyle = '';
    this.aggregationStyle = '';
    this.isReaggregation = false;
    this.fileAggregated = false;
    this.step = 1;
  }

  private blobSetup(file: any) {
    const blobName = `${file.name}`;
    const containerClient = this.blobServiceClient.getContainerClient(this.Config.containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    const options: BlockBlobUploadOptions = {
      onProgress: (loadedBytes: any) => {
        const progress = Number(loadedBytes.loadedBytes);
        const total = this.currentFile.size;
        this.percent = (100 * progress) / total;
      },
    };
    return { blockBlobClient, options, blobName };
  }

  private uploadToAzure() {
    if (this.currentFile !== null) {
      Globals.importUpload = true;

      const azureUrl = this.Config.URL.substring(0, this.Config.URL.lastIndexOf('/'));
      this.blobServiceClient = new BlobServiceClient(`${azureUrl}?${this.Config.sas}`);
      const { blockBlobClient, options, blobName } = this.blobSetup(this.currentFile);

      this.currentFile.arrayBuffer().then(fileBuffer => {
        blockBlobClient
          .upload(fileBuffer, fileBuffer.byteLength, options)
          .then(uploadResult => {
            this.onFileUploadSuccess(1);
          })
          .catch(err => {
            this.onFileUploadFailure(err);
          })
          .finally(() => {
            this.importerService.importerStatus$.next(ImporterState.fileUploaded);
          });
      });
    }
  }

  private onFileUploadFailure(err: any) {
    console.log('Error:', err);
    Globals.importUpload = false;
    // this.importerService.importerStatus$.next(ImporterState.fileUploaded);
    this.getStepStyle(true);
  }

  private onFileUploadSuccess(type: number) {
    this.percent = 100;
    // this.importerService.importerStatus$.next(ImporterState.fileUploaded);
    this.getStepStyle(false);
    if (type === 1) {
      Globals.importUpload = false;
      this.initiateServerImportToDatabase();
    }
  }

  private isStepComplete(res: any): boolean {
    if (res.Finish_Time === '' && res.ImportErrors.length > 0) {
      return true;
    }

    if (res.Finish_Time !== '' && !res.Success) {
      return true;
    }

    return !res.Success && res.Finish_Time === '' ? false : true;
  }

  private setupActiveImport(res: any) {
    if (res.ActiveImportID > 0) {
      if (res.ActiveImportType === 1) {
        this.setupActiveFileImport(res);
      } else {
        //reaggregation
        this.setupActiveAggregation(res);
      }
    }
  }

  private setupActiveFileImport(res: any) {
    if (res.ActiveImportStage === 1) {
      this.onFileUploadSuccess(0);
      this.filename = res.ActiveImport_FileName;
      this.step = 2;
      this.importerService.importerStatus$.next(ImporterState.fileImporting);
      this.importStyle = this.getStepStyle(false);
      this.pollFileImport(res.ActiveImportID);
      this.importing = true;
    } else {
      this.setupActiveAggregation(res);
    }
  }

  private setupActiveAggregation(res: any) {
    this.filename = res.ActiveImport_FileName;
    this.import_datasets = res.ActiveImport_Datasets;
    for (let i = 1; i < 3; i++) {
      this.importerService.importerStatus$.next(i === 1 ? ImporterState.fileUploaded : ImporterState.fileImported);
      this.step = i;
      this.getStepStyle(false);
    }
    this.importing = true;
    if (res.ActiveImportType === 2) {
      this.isReaggregation = true;
      this.cpDate = res.ActiveImport_CP_Date;
    }
    this.step = 3;
    this.importerService.importerStatus$.next(ImporterState.fileAggregating);
    this.aggregationStyle = this.getStepStyle(false);
    this.fileUploaded = true;
    this.fileImported = true;
    this.fileAggregated = false;

    this.pollAggregation(res.ActiveImportID);
  }

  public initiateServerImportToDatabase() {
    this.step = 2;
    this.importerService.importerStatus$.next(ImporterState.fileImporting);
    this.importStyle = this.getStepStyle(false);
    this.datasetService
      .InititateFileImport(this.filename, json)
      .toPromise()
      .then((res: any) => {
        if (res.ImportID > 0) {
          this.pollFileImport(res.ImportID);
        } else {
          this.getStepStyle(true);
          this.importCompleteStyle = 'fail';
          if (this.importErrors.length === 0) {
            const error = {
              ErrorType: 'SystemError',
              ErrorText: 'Critical System Failure! Please check application logs',
              Dataset: '',
            };
            this.importErrors.push(error);
          }
        }
      });
  }

  private pollFileImport(ImportID: number) {
    interval(5000)
      .pipe(
        switchMap(() => this.datasetService.PollImport(ImportID, this.filename, 0)),
        map(data => data),
        distinctUntilChanged(),
        tap(value => this.importComplete(value)),
        takeWhile(data => !this.isStepComplete(data)),
        takeUntil(this.onDestroy$)
      )
      .subscribe(() => {});
  }

  private pollAggregation(ImportID: number) {
    interval(5000)
      .pipe(
        switchMap(() => this.datasetService.PollImport(ImportID, this.filename, 1)),
        map(data => data),
        tap(value => this.AggregationComplete(value)),
        takeWhile(data => !this.isStepComplete(data)),
        takeUntil(this.onDestroy$)
      )
      .subscribe(() => {});
  }

  private importComplete(res: any) {
    this.importErrors = res.ImportErrors;
    if (res.Success) {
      this.cpDate = res.AsOfDate;
      this.importerService.importerStatus$.next(ImporterState.fileImported);
      this.getStepStyle(false);
      const data: any[] = JSON.parse(res.Datasets);
      const datasets: string[] = [];
      data.forEach(elem => {
        datasets.push(elem.dataset);
      });
      this.import_datasets = datasets;
      this.initiateDatabaseAggregation(res.ImportID, datasets);
    } else if (!res.Success && res.Finish_Time !== '') {
      this.importerService.importerStatus$.next(ImporterState.fileImported);
      this.getStepStyle(true);
    } else {
      this.getStepStyle(true);
    }
  }

  public initiateDatabaseAggregation(importID: number, datasets: string[]) {
    this.step = 3;
    this.importerService.importerStatus$.next(ImporterState.fileAggregating);
    this.aggregationStyle = this.getStepStyle(false);
    this.datasetService
      .InititateAggregation(importID, datasets)
      .toPromise()
      .then((res: any) => {
        if (res.ImportID > 0) {
          this.pollAggregation(res.ImportID);
        } else {
          this.getStepStyle(true);
          this.aggregationCompleteStyle = 'fail';
          if (this.aggregationErrors.length === 0) {
            const error = {
              ErrorType: 'SystemError',
              ErrorText: 'Critical System Failure! Please check application logs',
              Dataset: '',
            };
            this.aggregationErrors.push(error);
          }
        }
      })
      .catch(err => {
        this.getStepStyle(true);
        this.aggregationCompleteStyle = 'softComplete';
        if (this.aggregationErrors.length === 0) {
          const error = {
            ErrorType: 'Network Error',
            ErrorText: 'An error has occured on the network. Aggregation is most likely still in progress',
            Dataset: '',
          };
          this.aggregationErrors.push(error);
        }
        return Promise.reject(err);
      });
  }

  public reAggregate(type: number) {
    this.importing = true;
    this.isReaggregation = true;
    this.datasetService
      .startReAggregation(type)
      .toPromise()
      .then((res: any) => {
        if (res.ImportID > 0) {
          this.fileUploaded = true;
          this.fileImported = true;
          this.fileAggregated = false;
          for (let i = 1; i < 3; i++) {
            this.importerService.importerStatus$.next(i === 1 ? ImporterState.fileUploaded : ImporterState.fileImported);
            this.step = i;
            this.getStepStyle(false);
          }
          this.cpDate = res.AsOfDate;
          const data: any[] = JSON.parse(res.Datasets);
          const datasets: string[] = [];
          data.forEach(elem => {
            datasets.push(elem.dataset);
          });
          this.initiateDatabaseAggregation(res.ImportID, datasets);
        } else {
          // Show error message
          this.notifications.showToast(ToastLevel.Error,{          
            message: 'Error initiating aggregation. Please contact administrator',
          } as Toast);
        }
      });
  }

  private AggregationComplete(res: any) {
    this.aggregationErrors = res.ImportErrors;
    if (res.Success) {
      // Fix 4786: Dismiss Import Notification Banner on success
      this.notifications.mainNotificationBanner$.next({ action: 'dismiss', name: 'import' });
      this.importerService.importerStatus$.next(ImporterState.fileAggregated);
      this.comp.setIsImported(true);
      this.fileAggregated = true;
      this.getStepStyle(false);
      this.importerService.reloadStoreAndCheckIfResultsOutOfDate();
    } else if (!res.Success && res.Finish_Time !== '') {
      this.importerService.importerStatus$.next(ImporterState.fileAggregated);
      this.getStepStyle(true);
    } else {
      this.getStepStyle(true);
    }
  }

  public getStepStyle(hasFailed: boolean): string {
    const running = 'active';
    const pass = 'complete';
    const fail = 'fail';
    const passWithErrors = 'softComplete';

    if (hasFailed) {
      switch (this.step) {
        case 1:
          this.uploadCompleteStyle = fail;
          break;
        case 2:
          this.importCompleteStyle = fail;
          break;
        case 3:
          this.aggregationCompleteStyle = fail;
      }
    }

    switch (this.step) {
      case 1:
        if (this.importerService.importerStatus$.getValue() === ImporterState.fileUploaded) {
          this.uploadCompleteStyle = hasFailed ? fail : pass;
        }
        break;

      case 2:
        if (this.importerService.importerStatus$.getValue() === ImporterState.fileImported) {
          if (!hasFailed) {
            if (this.importErrors.length === 0) {
              this.importCompleteStyle = pass;
            } else {
              let failure = false;
              this.importErrors.forEach(elem => {
                if (elem.ErrorType === 'ImportFailure') {
                  failure = true;
                }
              });
              if (failure) {
                this.importCompleteStyle = fail;
              } else {
                this.importCompleteStyle = passWithErrors;
              }
            }
          } else {
            this.importCompleteStyle = fail;
          }
        }
        break;

      case 3:
        if (this.importerService.importerStatus$.getValue() === ImporterState.fileAggregated) {
          if (!hasFailed) {
            if (this.aggregationErrors.length === 0) {
              this.aggregationCompleteStyle = pass;
            } else {
              let failure = false;
              this.aggregationErrors.forEach(elem => {
                if (elem.ErrorType === 'ImportFailure') {
                  failure = true;
                }
              });
              if (failure) {
                this.aggregationCompleteStyle = fail;
              } else {
                this.aggregationCompleteStyle = passWithErrors;
              }
            }
          } else {
            this.aggregationCompleteStyle = fail;
          }
        }
        break;
    }
    return running;
  }

  public viewErrors(type: number) {
    const mapErrorsToImportError = (err, step) => ({
      error_text: err.ErrorText,
      error_type: err.ErrorType,
      dataset: err.Dataset,
      ImportStep: step,
    });

    switch (type) {
      case 1:
        const importErrors: ImportError[] = this.importErrors.map(err => mapErrorsToImportError(err, 1));
        this.openErrorWindow(importErrors);
        break;
      case 2:
        const aggregationErrors: ImportError[] = this.aggregationErrors.map(err => mapErrorsToImportError(err, 2));
        this.openErrorWindow(aggregationErrors);
    }
  }

  public openErrorDialog(dataSetName: string = null) {
    this.lastImportErrorsFilter = dataSetName;
    this.openErrorWindow(this.aggregationErrors, this.lastImportErrorsFilter);
  }

  public closeErrorDialog() {
    this.isErrorDialogOpen = false;
  }

  public emitResize() {
    this.menu.emitResize();
  }

  public datasetHasErrors(datasetName: string = null) {
    if (datasetName) {
      return this.aggregationErrors.some(error => error.dataset.toLowerCase() === datasetName.toLowerCase());
    } else {
      return this.aggregationErrors.length > 0;
    }
  }

  public importHasErrors() {
    return this.importErrors.length > 0;
  }

  openErrorWindow(content: ImportError[], filterBy = '') {
    const kendoOptions = {
      appendTo: this.containerRef,
      title: `Dataset Errors`,
      content: ImportErrorDisplayComponent,
      top: 100,
      width: 800,
      height: 500,
      minWidth: 600,
      minHeight: 350,
      unique: true,
    };

    if (!this.isErrorDialogOpen) {
      this.isErrorDialogOpen = true;
      this.windowRef = this.windowService.open(kendoOptions);
      this.windowRef.content.location.nativeElement.focus();

      const componentInstance = this.windowRef.content.instance;
      componentInstance.filterBy = filterBy;
      componentInstance.errorList = content;

      this.subscription = this.windowRef.result.subscribe((result: any) => {
        this.isErrorDialogOpen = false;
        this.subscription.unsubscribe();
      });
    }
  }
}
